export default {
      id: "instagram-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg/sprite.svg#instagram",
      toString: function () {
        return this.url;
      }
    }